'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _require = require('url'),
    fileURLToPath = _require.fileURLToPath,
    pathToFileURL = _require.pathToFileURL;

var _require2 = require('path'),
    resolve = _require2.resolve,
    isAbsolute = _require2.isAbsolute;

var _require3 = require('nanoid/non-secure'),
    nanoid = _require3.nanoid;

var lineColumn = require('line-column');

var terminalHighlight = require('./terminal-highlight');

var CssSyntaxError = require('./css-syntax-error');

var PreviousMap = require('./previous-map');

var Input = /*#__PURE__*/function () {
  function Input(css) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Input);

    if (css === null || typeof css === 'undefined' || typeof css === 'object' && !css.toString) {
      throw new Error("PostCSS received ".concat(css, " instead of CSS string"));
    }

    this.css = css.toString();

    if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    if (opts.from) {
      if (/^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
        this.file = opts.from;
      } else {
        this.file = resolve(opts.from);
      }
    }

    var map = new PreviousMap(this.css, opts);

    if (map.text) {
      this.map = map;
      var file = map.consumer().file;
      if (!this.file && file) this.file = this.mapResolve(file);
    }

    if (!this.file) {
      this.id = '<input css ' + nanoid(6) + '>';
    }

    if (this.map) this.map.file = this.from;
  }

  _createClass(Input, [{
    key: "fromOffset",
    value: function fromOffset(offset) {
      var finder = lineColumn(this.css);

      this.fromOffset = function (i) {
        return finder.fromIndex(i);
      };

      return this.fromOffset(offset);
    }
  }, {
    key: "error",
    value: function error(message, line, column) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var result;

      if (!column) {
        var pos = this.fromOffset(line);
        line = pos.line;
        column = pos.col;
      }

      var origin = this.origin(line, column);

      if (origin) {
        result = new CssSyntaxError(message, origin.line, origin.column, origin.source, origin.file, opts.plugin);
      } else {
        result = new CssSyntaxError(message, line, column, this.css, this.file, opts.plugin);
      }

      result.input = {
        line: line,
        column: column,
        source: this.css
      };

      if (this.file) {
        result.input.url = pathToFileURL(this.file).toString();
        result.input.file = this.file;
      }

      return result;
    }
  }, {
    key: "origin",
    value: function origin(line, column) {
      if (!this.map) return false;
      var consumer = this.map.consumer();
      var from = consumer.originalPositionFor({
        line: line,
        column: column
      });
      if (!from.source) return false;
      var fromUrl;

      if (isAbsolute(from.source)) {
        fromUrl = pathToFileURL(from.source);
      } else {
        fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL(this.map.mapFile));
      }

      var result = {
        url: fromUrl.toString(),
        line: from.line,
        column: from.column
      };

      if (fromUrl.protocol === 'file:') {
        result.file = fileURLToPath(fromUrl);
      }

      var source = consumer.sourceContentFor(from.source);
      if (source) result.source = source;
      return result;
    }
  }, {
    key: "mapResolve",
    value: function mapResolve(file) {
      if (/^\w+:\/\//.test(file)) {
        return file;
      }

      return resolve(this.map.consumer().sourceRoot || this.map.root || '.', file);
    }
  }, {
    key: "from",
    get: function get() {
      return this.file || this.id;
    }
  }]);

  return Input;
}();

module.exports = Input;

if (terminalHighlight && terminalHighlight.registerInput) {
  terminalHighlight.registerInput(Input);
}